import Reflection from '../reflection.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Reflection.store((data, fetch) =>
  fetch.post('/reflections', data)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
